import { render, staticRenderFns } from "./HotSwiper.vue?vue&type=template&id=2178fe21&scoped=true&"
import script from "./HotSwiper.vue?vue&type=script&lang=js&"
export * from "./HotSwiper.vue?vue&type=script&lang=js&"
import style0 from "./HotSwiper.vue?vue&type=style&index=0&id=2178fe21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178fe21",
  null
  
)

export default component.exports